import React from 'react';
import { Page } from 'components';
import { CountriesProvider } from './CountriesContext';
import Countries from './Countries';


let Index = () => {
    return (
        <CountriesProvider>
            <Page title="Countries">
                <Countries />
            </Page>
        </CountriesProvider>
    );
}

export default Index;